function e(r) {
  var a = r.images;
  return a ? '<drawing r:id="rId1"/>' : "";
}
export {
  e as default
};
//# sourceMappingURL=index.es506.js.map
